var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',{ref:"elementBox",staticClass:"tile-chart-card-element"},[_c('el-main',{staticClass:"tile-chart-card-element-body"},[_vm._t("element-content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }